import { uniqBy } from "lodash";
import type { ApAgentRun, ApPage } from "@/accounts-payable/types";
import { isPendingReviewAction } from "./action-review";

export const flattenPages = <T extends { id: string }>(
  pages: ApPage<T>[] | undefined,
): T[] => uniqBy(pages?.flatMap((page) => page.items) ?? [], (item) => item.id);

export const getLatestCompletedRun = (runs: ApAgentRun[]) =>
  runs.find((run) => run.status === "completed");

export const isActiveRun = (run: ApAgentRun) =>
  run.status === "pending" || run.status === "running";

export const getActiveRun = (runs: ApAgentRun[]) => runs.find(isActiveRun);

export const ACTIVE_RUN_POLL_MS = 3000;

export const areRunsInFlight = (runs: ApAgentRun[]) =>
  runs.some((run) => {
    const actions = run.actions ?? [];
    const awaitingReview = new Set(
      actions.filter(isPendingReviewAction).map((action) => action.id),
    );
    return (
      isActiveRun(run) ||
      actions.some(
        (action) =>
          (action.status === "approved" &&
            !action.waiting_reason &&
            !(action.waiting_on_action_ids ?? []).some((id) =>
              awaitingReview.has(id),
            )) ||
          action.status === "applying" ||
          action.rollback_status === "rolling_back",
      )
    );
  });

export const runsInFlightRefetchInterval = (query: {
  state: { data?: ApAgentRun[] };
}) => (areRunsInFlight(query.state.data ?? []) ? ACTIVE_RUN_POLL_MS : false);
